import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function PageTransitionWrapper() {
  const location = useLocation();

  return (
    <div key={location.pathname} className="page-enter-animation">
      <AppRoutes />
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <PageTransitionWrapper />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
